/**
 * Aklanda Shopify Theme v2 — Main JavaScript
 */

document.addEventListener('DOMContentLoaded', function () {
  initMobileNav();
  initSearchOverlay();
  initProductGallery();
  initCartQty();
  initNewsletterForm();
  initNewsletterPopup();
  initScrollAnimations();
  initProductOptions();
  initHeroSlider();
  initCartDrawer();
  initProductForm();
  initProductTabs();
  initAnnouncementBar();
  initDropdowns();
});

/* ===== Search Overlay ===== */
function initSearchOverlay() {
  const toggle  = document.getElementById('search-toggle');
  const overlay = document.getElementById('search-overlay');
  const input   = overlay ? overlay.querySelector('input[type="search"]') : null;
  const close   = overlay ? overlay.querySelector('#search-close') : null;
  if (!toggle || !overlay) return;

  function openSearch() {
    overlay.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 50);
  }

  function closeSearch() {
    overlay.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    toggle.focus();
  }

  toggle.addEventListener('click', openSearch);
  if (close) close.addEventListener('click', closeSearch);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeSearch();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeSearch();
  });
}

/* ===== Mobile Navigation ===== */
function initMobileNav() {
  const btn = document.getElementById('hamburger-btn');
  const menu = document.getElementById('mobile-menu');
  const iconOpen = document.getElementById('icon-open');
  const iconClose = document.getElementById('icon-close');
  if (!btn || !menu) return;

  btn.addEventListener('click', function () {
    const isOpen = menu.classList.toggle('is-open');
    iconOpen.style.display  = isOpen ? 'none' : 'block';
    iconClose.style.display = isOpen ? 'block' : 'none';
    btn.setAttribute('aria-expanded', String(isOpen));
    menu.setAttribute('aria-hidden', String(!isOpen));
  });

  menu.querySelectorAll('a:not(.mobile-nav-child)').forEach(function (link) {
    link.addEventListener('click', function () {
      menu.classList.remove('is-open');
      iconOpen.style.display  = 'block';
      iconClose.style.display = 'none';
      btn.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
    });
  });
}

/* ===== Desktop & Mobile Dropdowns ===== */
function initDropdowns() {
  /* Desktop: toggle on click, close on outside click */
  document.querySelectorAll('.nav-item.has-dropdown > .nav-link--dropdown').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const item = btn.closest('.nav-item.has-dropdown');
      const isOpen = item.classList.contains('is-open');
      /* close all others */
      document.querySelectorAll('.nav-item.has-dropdown.is-open').forEach(function (el) { el.classList.remove('is-open'); el.querySelector('.nav-link--dropdown').setAttribute('aria-expanded', 'false'); });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('.nav-item.has-dropdown.is-open').forEach(function (el) { el.classList.remove('is-open'); el.querySelector('.nav-link--dropdown').setAttribute('aria-expanded', 'false'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.nav-item.has-dropdown.is-open').forEach(function (el) { el.classList.remove('is-open'); el.querySelector('.nav-link--dropdown').setAttribute('aria-expanded', 'false'); });
    }
  });

  /* Mobile: accordion toggle */
  document.querySelectorAll('.mobile-nav-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const item = btn.closest('.mobile-nav-item.has-children');
      item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(item.classList.contains('is-open')));
    });
  });
}

/* ===== Product Gallery Thumbnails ===== */
function initProductGallery() {
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.querySelector('.product-gallery-main img');
  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var src = thumb.dataset.src;
      if (src) {
        mainImg.src = src;
        mainImg.alt = thumb.dataset.alt || '';
      }
    });
  });
}

/* ===== Product Options ===== */
function initProductOptions() {
  document.querySelectorAll('.product-option-btns').forEach(function (group) {
    group.querySelectorAll('.product-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.product-option-btn').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
      });
    });
  });
}

/* ===== Cart Quantity Controls ===== */
function initCartQty() {
  document.querySelectorAll('.cart-qty').forEach(function (row) {
    var minusBtn = row.querySelector('[data-qty-minus]');
    var plusBtn  = row.querySelector('[data-qty-plus]');
    var input    = row.querySelector('input[name="updates[]"]');
    if (!input) return;

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) { input.value = val - 1; }
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 0;
        input.value = val + 1;
      });
    }
  });
}

/* ===== Newsletter Form ===== */
function initNewsletterForm() {
  var form = document.getElementById('newsletter-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var emailInput = form.querySelector('input[type="email"]');
    if (!emailInput || !emailInput.value) return;

    var params = new URLSearchParams({
      'contact[email]': emailInput.value,
      'form_type': 'customer',
      'utf8': '\u2713'
    });

    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString()
    }).then(function () {
      form.innerHTML = '<p style="color:var(--color-primary-fg);font-size:0.875rem;padding:0.5rem 0;">Thank you for subscribing!</p>';
    }).catch(function () {
      console.error('Newsletter subscription failed');
    });
  });
}

/* ===== Newsletter Popup (3-hour cookie) ===== */
function initNewsletterPopup() {
  var popup   = document.getElementById('newsletter-popup');
  if (!popup) return;

  var overlay = document.getElementById('nl-popup-overlay');
  var closeBtn = document.getElementById('nl-popup-close');
  var COOKIE  = 'akl_nl_shown';

  function getCookie(name) {
    var match = document.cookie.match('(?:^|;)\\s*' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCookie(name, value, hours) {
    var exp = new Date(Date.now() + hours * 3600000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + exp + ';path=/';
  }

  function dismissPopup() {
    popup.hidden = true;
    document.body.style.overflow = '';
    setCookie(COOKIE, '1', 3);
  }

  function showPopup() {
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  /* If Shopify redirected back after successful form submit */
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    setCookie(COOKIE, '1', 3);
    /* Show success state if popup exists */
    var content = popup.querySelector('.nl-popup__content');
    if (content) {
      content.innerHTML = '<div class="nl-popup__success"><h3>You\'re in!</h3><p>Thanks for subscribing. Watch your inbox for Merino stories and exclusive offers.</p></div>';
      showPopup();
      setTimeout(dismissPopup, 3500);
    }
    return;
  }

  /* Don't show if cookie already set */
  if (getCookie(COOKIE)) return;

  /* Show after 2.5s delay */
  setTimeout(showPopup, 2500);

  if (closeBtn) closeBtn.addEventListener('click', dismissPopup);
  if (overlay)  overlay.addEventListener('click', dismissPopup);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) dismissPopup();
  });
}

/* ===== Scroll-triggered Animations ===== */
function initScrollAnimations() {
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('[data-animate]').forEach(function (el) {
    observer.observe(el);
  });

  /* ---- Counter Animation for stat values ---- */
  initCounterAnimation();
}

function initCounterAnimation() {
  if (!('IntersectionObserver' in window)) return;

  var counterObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      counterObserver.unobserve(entry.target);
      animateCounter(entry.target);
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.stat-value').forEach(function (el) {
    counterObserver.observe(el);
  });
}

function animateCounter(el) {
  var text = el.textContent.trim();
  // Extract leading number (e.g. "35+" → 35, "100%" → 100, "1988" → 1988)
  var match = text.match(/^([\d.]+)/);
  if (!match) return;               // Non-numeric like "Melbourne" — skip

  var target   = parseFloat(match[1]);
  var suffix   = text.slice(match[0].length);  // "+", "%", "μm" etc.
  var duration = 1600;
  var startTime = null;
  var startVal = Math.max(0, target - (target > 100 ? 200 : target > 10 ? 20 : target));

  function step(ts) {
    if (!startTime) startTime = ts;
    var progress = Math.min((ts - startTime) / duration, 1);
    // Ease-out-expo
    var ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
    var current = Math.round(startVal + (target - startVal) * ease);
    el.textContent = current + suffix;
    if (progress < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

/* ===== Hero Slider ===== */
function initHeroSlider() {
  var slider = document.getElementById('akl-hero');
  if (!slider) return;

  var track     = slider.querySelector('.hero-slider__track');
  var slides    = slider.querySelectorAll('.hero-slide');
  var prevBtn   = slider.querySelector('.hero-slider__arrow--prev');
  var nextBtn   = slider.querySelector('.hero-slider__arrow--next');
  var dots      = slider.querySelectorAll('.hero-slider__dot');
  var total     = slides.length;
  if (total <= 1) return;

  var current        = 0;
  var autoplay       = slider.dataset.autoplay === 'true';
  var autoplaySpeed  = parseInt(slider.dataset.autoplaySpeed, 10) || 7000;
  var transition     = slider.dataset.navigation;
  var autoplayTimer  = null;

  function goTo(index, dir) {
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = (index + total) % total;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
  }

  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    autoplayTimer = setInterval(function () { goTo(current + 1); }, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
  }

  // Set initial active
  slides[0].classList.add('is-active');
  track.style.transform = 'translateX(0)';

  if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); goTo(current - 1); startAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); goTo(current + 1); startAutoplay(); });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { stopAutoplay(); goTo(i); startAutoplay(); });
  });

  // Touch/swipe
  var touchStartX = 0;
  slider.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
  slider.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) { stopAutoplay(); goTo(diff > 0 ? current + 1 : current - 1); startAutoplay(); }
  }, { passive: true });

  startAutoplay();
}

/* ===== Cart Drawer ===== */
function initCartDrawer() {
  var drawer  = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var closeBtn = document.getElementById('cart-drawer-close');
  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Expose globally for product form
  window.aklOpenCartDrawer = openDrawer;
  window.aklCloseCartDrawer = closeDrawer;

  // Update cart count badge on header link
  window.aklUpdateCartCount = function (count) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; el.style.display = count > 0 ? '' : 'none'; });
    var drawerCount = document.getElementById('cart-drawer-count');
    if (drawerCount) drawerCount.textContent = count;
  };

  refreshCartDrawer();
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCartDrawer(cart);
    })
    .catch(function (e) { console.error('Cart fetch failed', e); });
}

function renderCartDrawer(cart) {
  var body     = document.getElementById('cart-drawer-body');
  var subtotal = document.getElementById('cart-drawer-subtotal');
  var footer   = document.getElementById('cart-drawer-footer');
  if (!body) return;

  if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  if (window.aklUpdateCartCount) window.aklUpdateCartCount(cart.item_count);

  if (cart.item_count === 0) {
    body.innerHTML = '<div class="cart-drawer__empty"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg><p>Your cart is empty</p><a href="/collections/all" class="btn btn-primary">Continue Shopping</a></div>';
    if (footer) footer.style.display = 'none';
    return;
  }

  if (footer) footer.style.display = '';

  var html = '<ul class="cart-drawer__items">';
  cart.items.forEach(function (item) {
    html += '<li class="cart-drawer__item" data-key="' + item.key + '">';
    if (item.image) {
      html += '<a href="' + item.url + '" class="cart-item__img-wrap"><img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy"></a>';
    }
    html += '<div class="cart-item__info">';
    html += '<a href="' + item.url + '" class="cart-item__title">' + escapeHtml(item.product_title) + '</a>';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      html += '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>';
    }
    html += '<div class="cart-item__row">';
    html += '<div class="cart-item__qty">';
    html += '<button class="qty-btn cart-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>';
    html += '<span class="cart-item__qty-num">' + item.quantity + '</span>';
    html += '<button class="qty-btn cart-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>';
    html += '</div>';
    html += '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>';
    html += '</div>';
    html += '</div>';
    html += '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="Remove item">×</button>';
    html += '</li>';
  });
  html += '</ul>';
  body.innerHTML = html;

  // Bind qty + remove events
  body.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty, 10));
    });
  });
  body.querySelectorAll('.cart-item__remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      updateCartItem(btn.dataset.key, 0);
    });
  });
}

function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCartDrawer(cart); })
    .catch(function (e) { console.error('Cart update failed', e); });
}

function formatMoney(cents) {
  var amount = (cents / 100).toFixed(2);
  return '$' + amount;
}

function escapeHtml(str) {
  var div = document.createElement('div');
  div.appendChild(document.createTextNode(str || ''));
  return div.innerHTML;
}

/* ===== Product Form — AJAX Add to Cart + Variant Updates ===== */
function initProductForm() {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var productId   = form.closest('[id^="product-json-"]');
  var jsonScript  = document.querySelector('[id^="product-json-"]');
  if (!jsonScript) return;

  var productData;
  try { productData = JSON.parse(jsonScript.textContent); } catch (e) { return; }

  var variantInput  = document.getElementById('product-variant-id');
  var priceEl       = document.getElementById('product-price');
  var availEl       = document.getElementById('product-availability');
  var addBtn        = document.getElementById('add-to-cart-btn');
  var atcText       = addBtn ? addBtn.querySelector('.atc-text') : null;
  var atcSpinner    = addBtn ? addBtn.querySelector('.atc-spinner') : null;
  var mainImg       = document.getElementById('main-product-image');

  // Current selected options
  var selectedOptions = productData.options.map(function (_, i) {
    var selectedBtn = document.querySelector('.product-option-btns[data-option-index="' + i + '"] .product-option-btn.is-selected, [data-option-index="' + i + '"].product-option-btns .is-selected');
    return selectedBtn ? selectedBtn.dataset.optionValue : productData.variants[0]['option' + (i + 1)];
  });
  // Fallback: use first available variant options
  if (productData.variants && productData.variants.length > 0) {
    var firstV = productData.variants[0];
    selectedOptions = [firstV.option1, firstV.option2, firstV.option3].filter(Boolean);
  }

  function findVariant(options) {
    return productData.variants.find(function (v) {
      return options.every(function (opt, i) {
        return v['option' + (i + 1)] === opt;
      });
    });
  }

  function updateVariantUI(variant) {
    if (!variant) return;

    if (variantInput) variantInput.value = variant.id;

    // Price
    if (priceEl) {
      var html = '';
      if (variant.compare_at_price > variant.price) {
        html += '<span class="price-was">$' + (variant.compare_at_price / 100).toFixed(2) + '</span>';
        html += '<span class="price-badge">Sale</span>';
      }
      html += '<span class="price-current">$' + (variant.price / 100).toFixed(2) + '</span>';
      priceEl.innerHTML = html;
    }

    // Availability
    if (availEl) {
      availEl.innerHTML = variant.available
        ? '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> In stock, ready to ship'
        : 'Out of stock';
    }

    // Button
    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    // Image — switch to variant's image
    if (variant.featured_image && mainImg) {
      var src = variant.featured_image.src;
      // Shopify CDN pattern for resizing
      src = src.replace(/(\.[^.]+)$/, '_900x$1');
      mainImg.src = src;
      mainImg.alt = variant.featured_image.alt || '';
      // Also activate matching thumb
      document.querySelectorAll('.product-thumb').forEach(function (thumb) {
        var vid = parseInt(thumb.dataset.variantId, 10);
        if (vid === variant.id) {
          document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }
      });
    }

    // Update URL
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  // Bind option buttons
  document.querySelectorAll('.product-option-group').forEach(function (group) {
    var idx = parseInt(group.dataset.optionIndex, 10);
    group.querySelectorAll('.product-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.product-option-btn').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        selectedOptions[idx] = btn.dataset.optionValue;
        // Update inline label (e.g. "Color: Egg Blue")
        var labelTarget = btn.dataset.labelTarget;
        if (labelTarget) {
          var labelEl = document.getElementById(labelTarget);
          if (labelEl) labelEl.textContent = btn.dataset.optionValue;
        }
        var variant = findVariant(selectedOptions);
        updateVariantUI(variant);
      });
    });
  });

  // AJAX add to cart
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!addBtn || addBtn.disabled) return;

    var variantId = parseInt(variantInput.value, 10);
    var qty       = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;

    if (atcText) atcText.style.display = 'none';
    if (atcSpinner) atcSpinner.style.display = '';
    addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (atcText) { atcText.textContent = 'Added!'; atcText.style.display = ''; }
        if (atcSpinner) atcSpinner.style.display = 'none';

        showToast(item.product_title + ' added to cart');

        if (window.aklOpenCartDrawer) window.aklOpenCartDrawer();

        setTimeout(function () {
          if (atcText) atcText.textContent = 'Add to Cart';
          addBtn.disabled = false;
        }, 2000);
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        if (atcText) { atcText.textContent = 'Add to Cart'; atcText.style.display = ''; }
        if (atcSpinner) atcSpinner.style.display = 'none';
        addBtn.disabled = false;
      });
  });
}

function showToast(message) {
  var toast = document.getElementById('atc-toast');
  var text  = document.getElementById('atc-toast-text');
  if (!toast) return;
  if (text) text.textContent = message;
  toast.hidden = false;
  toast.classList.add('is-visible');
  setTimeout(function () {
    toast.classList.remove('is-visible');
    setTimeout(function () { toast.hidden = true; }, 300);
  }, 3000);
}

/* ===== Product Tabs ===== */
function initProductTabs() {
  var tabBtns = document.querySelectorAll('.product-tab-btn');
  var tabPanels = document.querySelectorAll('.product-tab-panel');
  if (!tabBtns.length) return;

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.dataset.tab;
      tabBtns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
      tabPanels.forEach(function (p) { p.classList.remove('is-active'); p.hidden = true; });
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');
      var panel = document.getElementById('tab-' + target);
      if (panel) { panel.classList.add('is-active'); panel.hidden = false; }
    });
  });
}

/* ===== Announcement Bar Rotator ===== */
function initAnnouncementBar() {
  var slider = document.getElementById('announce-slider');
  if (!slider) return;
  var items = slider.querySelectorAll('.announcement-bar__text');
  if (items.length <= 1) return;

  var speed = parseInt(slider.closest('.announcement-bar') && slider.closest('[data-rotate-speed]') ? slider.closest('[data-rotate-speed]').dataset.rotateSpeed : '4', 10) * 1000 || 4000;
  var current = 0;

  setInterval(function () {
    items[current].classList.remove('is-active');
    current = (current + 1) % items.length;
    items[current].classList.add('is-active');
  }, speed);
}
